import { Paper, Popper } from "@mui/material";

const { useRef, useState } = require("react");

const CommentColumn = ({ value, shortValue }) => {
  const commentRef = useRef(null);
  const [showExtendedComment, setShowExtendedComment] = useState(false);
  return (
    <div
      ref={commentRef}
      onMouseEnter={() => setShowExtendedComment(true)}
      onMouseLeave={() => setShowExtendedComment(false)}
    >
      {shortValue}
      <Popper
        open={showExtendedComment}
        anchorEl={commentRef.current}
        placement="bottom-end"
      >
        <Paper
          elevation={4}
          style={{ padding: "10px", maxWidth: "300px" }}
          onClick={(e) => e.stopPropagation()}
        >
          {value}
        </Paper>
      </Popper>
    </div>
  );
};

export default CommentColumn;
